import ButtonStyles from 'styles/theme/Button';

export default class LoginAndPermissionStyles {
    static list(theme) {
        return ({
            root: {
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                flex: 1,
                minHeight: 0,
                height: '100%',
            },
            header: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexShrink: 0,
                minHeight: 56,
                padding: theme.spacing(1.5, 2),
                backgroundColor: theme.palette.background.white,
                borderBottom: `1px solid ${theme.palette.border.ghost}`,
            },
            headerLeft: {
                display: 'flex',
                alignItems: 'center',
                flexShrink: 0,
            },
            headerRight: {
                display: 'flex',
                alignItems: 'center',
                flexShrink: 0,
                gap: theme.spacing(1),
            },
            search: {
                width: 380,
            },
            filterSelect: {
                minWidth: 170,
            },
            box: {
                flex: 1,
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                padding: '10px',
            },
            tableGrid: {
                flex: 1,
                minHeight: 0,
                overflowX: 'auto',
                overflowY: 'hidden',
            },
            tableContainer: {
                marginTop: '15px',
                paddingLeft: '15px',
                paddingRight: '15px',
                height: 'calc(100% - 15px)',
                overflow: 'hidden',
                minWidth: '1400px',
                '& .ReactVirtualized__Table__row': {
                    cursor: 'pointer',
                },
            },
            tableHeader: {
                textAlign: 'left',
                color: theme.palette.text.waterloo,
                borderRight: `1px solid ${theme.palette.border.ghost}`,
                height: '100%',
                alignItems: 'center',
            },
            text: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
            statusDot: {
                width: 10,
                height: 10,
                borderRadius: '50%',
                display: 'inline-block',
            },
            statusActive: {
                backgroundColor: theme.palette.background.fruitSalad,
            },
            statusInactive: {
                backgroundColor: theme.palette.text.statusGray,
            },
            ...ButtonStyles.getStyle(theme),
        });
    }
}
